import { useEffect, useState } from 'react';

import { authStorage } from 'utils/storage';

export function useSubscriptionAccess() {
  const [hasSubscriptionAccess, setHasSubscriptionAccess] = useState(authStorage.hasActiveSubscription());

  useEffect(() => {
    const updateSubscription = () => setHasSubscriptionAccess(authStorage.hasActiveSubscription());

    window.addEventListener('storage', updateSubscription);
    window.addEventListener('subscription-change', updateSubscription);

    return () => {
      window.removeEventListener('storage', updateSubscription);
      window.removeEventListener('subscription-change', updateSubscription);
    };
  }, []);

  return hasSubscriptionAccess;
}
